module.exports = __webpack_public_path__ + "static/media/Right legs07.a827e21d.png";